export default __webpack_public_path__ + "static/media/z3plus.4a0c1e93.webp";